import { Box, Typography } from "@mui/material";
import EngineeringIcon from "@mui/icons-material/Engineering";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import SecurityIcon from "@mui/icons-material/Security";
import PublicIcon from "@mui/icons-material/Public";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const features = [
  {
    icon: <EngineeringIcon sx={{ fontSize: 42, color: brandRed }} />,
    title: "Certified Excellence",
    desc: "We are ISO Certified – 9001 / 14001 / 45001 ensuring the highest industry standards.",
  },
  {
    icon: <DesignServicesIcon sx={{ fontSize: 42, color: brandRed }} />,
    title: "Professional Skill Growth",
    desc: "Get trained and mentored by experienced industrial engineering experts.",
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 42, color: brandRed }} />,
    title: "Safety First Culture",
    desc: "Work within a highly safe, supportive and compliance-driven environment.",
  },
  {
    icon: <PublicIcon sx={{ fontSize: 42, color: brandRed }} />,
    title: "Global Projects Exposure",
    desc: "Collaborate on major power generation and infrastructure projects worldwide.",
  },
];

const WhyWorkWithUs = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background: "linear-gradient(135deg, #f3f6ff 0%, #e6ecf9 100%)",
      }}
    >
      <Typography
        variant="h4"
        fontWeight={800}
        align="center"
        sx={{
          color: brandBlue,
          mb: 1,
          fontSize: { xs: "1.8rem", md: "2.5rem" },
        }}
      >
        Why Work With Us?
      </Typography>

      <Box
        sx={{
          width: 90,
          height: 4,
          background: brandRed,
          mx: "auto",
          borderRadius: 2,
          mb: 3,
        }}
      />

      <Typography
        variant="h6"
        align="center"
        sx={{
          maxWidth: 650,
          mx: "auto",
          mb: 7,
          color: "#555",
          fontSize: { xs: "0.95rem", md: "1.15rem" },
        }}
      >
        Join a motivated team delivering precision-engineered solutions that
        power industries worldwide.
      </Typography>

      {/* FLEXBOX WRAPPER */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 4,
          px: { xs: 2, md: 10 },
        }}
      >
        {features.map((item, index) => (
          <Box
            key={index}
            sx={{
              flex: "1 1 300px", // responsive 3 per row
              maxWidth: "330px",
              p: 4,
              background: "#ffffffaa",
              borderRadius: 4,
              textAlign: "center",
              minHeight: "280px", // equal height
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              backdropFilter: "blur(6px)",
              border: "1px solid #e0e6f5",
              transition: "all 0.35s",
              boxShadow: "0 4px 18px rgba(0,0,0,0.06)",
              "&:hover": {
                transform: "translateY(-8px)",
                borderColor: brandRed,
                boxShadow: "0 10px 28px rgba(0,0,0,0.12)",
              },
            }}
          >
            {/* ICON CIRCLE */}
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "#ffffff",
                border: `3px solid ${brandRed}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                transition: "0.3s",
                "&:hover": {
                  background: brandRed,
                  "& svg": {
                    color: "#fff",
                  },
                },
              }}
            >
              {item.icon}
            </Box>

            <Typography
              fontWeight={700}
              sx={{
                fontSize: { xs: "1rem", md: "1.2rem" },
                color: brandBlue,
              }}
              mb={1}
            >
              {item.title}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#444",
                maxWidth: 240,
              }}
            >
              {item.desc}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default WhyWorkWithUs;
